import * as React from 'react';
import { SVGProps } from 'react';

const SvgCloseFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM7.707 7.707a1 1 0 0 1 1.414 0l2.829 2.829 2.828-2.829a1 1 0 1 1 1.414 1.414l-2.828 2.829 2.828 2.828a1 1 0 0 1-1.414 1.414l-2.828-2.828-2.829 2.828a1 1 0 0 1-1.414-1.414l2.829-2.828L7.707 9.12a1 1 0 0 1 0-1.414Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgCloseFilled;
